module.exports = __webpack_public_path__ + "static/media/Image_1_fo.43001c09.png";